import React from 'react';

import { SpendTypeEnum } from 'components/Classification';
import { ApiContext } from 'context/ApiContext';
import { LoaderWrapper, Wrapper } from '../styles';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { ProductAllocationController } from './ProductAllocationController';
import { getAllocations } from 'utils/api';
import { contributionField } from 'components/SpendAllocation/utils';
import { IAllocatedYear } from 'components/SpendAllocation/types';

interface IState {
  availableYears: number[] | null;
}

interface IProps {
  spendType: SpendTypeEnum;
}

export class ProductAllocationContainer extends React.Component<
  IProps,
  IState
> {
  state = {
    availableYears: null as IState['availableYears'],
  };

  componentDidMount() {
    this.fetchApplicationsAllocations();
  }

  fetchApplicationsAllocations = () => {
    const { spendType } = this.props;

    return getAllocations({
      contribution: contributionField[spendType],
    }).then((allocationsByYears) => {
      this.setState({
        availableYears: allocationsByYears.map(
          (item: IAllocatedYear) => item.year
        ),
      });
    });
  };

  render() {
    const { availableYears } = this.state;

    return (
      <Wrapper>
        <ApiContext.Consumer>
          {({ permissions, settings, format }) => {
            if (!settings || !availableYears) {
              return (
                <LoaderWrapper>
                  <ApLoaderDefault loaderText={() => <ApLoaderText />} />
                </LoaderWrapper>
              );
            }

            return (
              <ProductAllocationController
                {...this.props}
                settings={settings}
                permissions={permissions}
                format={format}
                availableYears={availableYears}
              />
            );
          }}
        </ApiContext.Consumer>
      </Wrapper>
    );
  }
}
